<template>
    <div ref="fieldsgeneratorpivot">
        <v-expansion-panels v-model="panel" focusable accordion class="pivot-expansion">        
            <v-expansion-panel class="background-2">
                <v-expansion-panel-header>
                    <div class="d-flex align-center">
                        <v-icon color="primary" class="mr-2">mdi-view-grid-plus</v-icon>
                        <span class="subtitle-1 font-weight-medium">{{ field.label }}</span>
                    </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="px-0 pt-4">
                    <v-row v-for="(row, r) in model[field.key]" class="ma-0 pa-0" :key="field.key+'_'+r">
                        <v-col class="col-10 pa-0">
                            <fields-generator :key="field.key+r"
                                :fieldsset.sync="fieldsset"
                                :model="row"
                                ref="fieldsgeneratorpivot"
                            ></fields-generator>
                        </v-col>
                        <v-col class="col-2 pa-0">
                            <v-btn color="error" ripple icon dark class="flex margin-auto mt-0 mb-0 float-right" @click="deleteRaw(r)">
                                <v-icon>delete</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>                    
                    <v-spacer></v-spacer>
                    <v-btn color="primary" fab small dark class="flex margin-auto mt-0 mb-0 float-right" @click="pushRaw()">
                        <v-icon>add</v-icon>
                    </v-btn>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>

    import Vue from 'vue'

	export default {
        name: 'fieldspivot-generator',
		components: {
			FieldsGenerator: () => import ('@/components/common/FieldsGenerator')
		},        
		props: {
            field: Object,	
            model: Object,	
		},

		data() {
			return {
                panel: true
            }
        },

        computed: {

            modelForWatcher() {
                return this.model[this.field.key]
            },

            fieldsset() {
                return this.field.options[0]
            },
            
            functions() {
                return this.field.options[0] ? this.field.options[0].functions : null
            }
        },

        watch: {
            modelForWatcher: {
                handler() {
                    this.callFunctions()
                    //this.$emit('pivotModelUpdated' + this.field.key, this.model[this.field.key])
                },
                deep: true
            }
        },

		methods: {

            callFunctions() {
                _.forEach(this.functions, (func) => {
                    switch(func.type) {
                    case 'sum':
                        this.sum(func)
                        break;
                    default:
                        return null
                    }                    
                })
            },

            sum(func) {
                var sum = 0
                
                _.forEach(this.model[this.field.key], (key) => {
                    if(_.hasIn(key, func.source)) {
                        sum += parseInt(key[func.source] == '' ? 0 : key[func.source])
                    }
                })
                Vue.set(this.model, func.target, sum)
            },

            pushRaw() {
                this.model[this.field.key].push({})
            },

            deleteRaw(r) {
                this.model[this.field.key].splice(r, 1)
            },
        },

        mounted() {
            if(!this.model[this.field.key]) {
                Vue.set(this.model, this.field.key, [])
            }
        }
    }
    </script>
    <style>
        .pivot-expansion .v-expansion-panel::before {
            box-shadow: none !important;            
            padding-top: 12px;
        }
        
        .pivot-expansion .v-expansion-panel-content__wrap {
            padding-left: 0 !important;
        }

        /* Correggo i selettori per i temi */
        .theme--dark .pivot-expansion .v-expansion-panel-content {
            border: 1px solid rgba(255, 255, 255, 0.12) !important;
        }
        
        .theme--light .pivot-expansion .v-expansion-panel-content {
            border: 1px solid rgba(0, 0, 0, 0.12) !important;
        }
        
        .theme--dark .pivot-expansion {
            border: 1px solid rgba(255, 255, 255, 0.12) !important;
        }
        
        .theme--light .pivot-expansion {
            border: 1px solid rgba(0, 0, 0, 0.12) !important;
        }
    </style>